import React from "react";
import InfoTile from "./InfoTile";
import {CoreAppDetailsResponse} from "../../../logic/APITypes";

type CoreAppTileProps = {
  appDetails: CoreAppDetailsResponse;
  appId: string;
};

/** Tile specific to core applications */
function CoreAppTile({appDetails}: CoreAppTileProps) {
  return (
    <>
      <InfoTile
        currentVersion={appDetails.current_app_version}
        latestVersion={undefined}
        homeUrl={appDetails.home_url}
      ></InfoTile>
    </>
  );
}

export default CoreAppTile;
